function retrieve(sessionStorageKey: string): any {
  try {
    const dataStr = sessionStorage.getItem(sessionStorageKey);
    return dataStr || null;
  } catch (e) {
    return null;
  }
}

function save(sessionStorageKey: string, data: string) {
  sessionStorage.setItem(sessionStorageKey, data);
}

function cleanKey(sessionStorageKey: string): void {
  sessionStorage.removeItem(sessionStorageKey);
}

function retrieveJSON(sessionStorageKey: string): any {
  const dataStr = sessionStorage.getItem(sessionStorageKey);
  if (!dataStr) { return null; }
  try {
    const dataJson = JSON.parse(dataStr);
    return dataJson || null;
  } catch (e) {
    return null;
  }
}

function saveJSON(sessionStorageKey: string, data: any) {
  sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
}

function clean(): void {
  sessionStorage.clear();
}

export const sessionStorageKeeperService = {
  retrieve,
  save,
  clean,
  retrieveJSON,
  saveJSON,
  cleanKey,
};
